/**
 * employee-accounts-dialog.tsx — Gán tài khoản giao tiếp cho MỘT nhân viên (cột "Kênh phụ trách").
 *
 * Chỉ là khung hộp thoại: danh sách kênh + mức quyền (Quản lý kênh | Tiếp nhận) dùng chung `MemberAccountsPanel`
 * với tab "Phân quyền theo kênh" — trước đây hai nơi chép riêng cùng một danh sách và lệch nhau.
 */
import { useTranslation } from 'react-i18next'
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '@/components/ui/dialog'
import type { TeamMember } from '@/hooks/use-settings'
import { MemberAccountsPanel } from './member-channel-access-view'

interface Props {
  member: TeamMember | null
  onClose: () => void
}

export function EmployeeAccountsDialog({ member, onClose }: Props) {
  const { t } = useTranslation('team')
  return (
    <Dialog open={!!member} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-base">{t('employeeAccountsDialog.title')}</DialogTitle>
          <DialogDescription className="text-xs">
            {member?.fullName || member?.email} — {t('employeeAccountsDialog.description')}
          </DialogDescription>
        </DialogHeader>
        {member && <MemberAccountsPanel member={member} className="max-h-[28rem] overflow-y-auto" />}
      </DialogContent>
    </Dialog>
  )
}
